// removed by extract-text-webpack-plugin
module.exports = {"border":"_1d5QtSwZOwprVdjPssPV8u","mode":"_33zOGaZ4e38U43m3lIR4bD","identifier":"_1g2BQlJ4RmQzO7sH0D5AxW","unsubscribeButton":"_3JWHwui2MHYxH82VbMXz43"};


//////////////////
// WEBPACK FOOTER
// ./app/javascript/containers/status/manage/styles.scss
// module id = 1286
// module chunks = 16